const headerElm = $("#header");

export function clickResetButton() {
  let back_button = $(".btn_reset button");
  let form_action = $(".h-adr");
  let setUrl = location;
  // console.log(form_action.attr('action'));
  back_button.on("click", function () {
    // history.back();

    location.href = setUrl.origin + "/recruit/entry/";
  });

  // 送信ボタンの有効無効

  function toggleSubmitBtn(flags) {
    let check_flag = flags.privacy;
    let check_mail_flag = flags.email;

    if (check_flag && check_mail_flag) {
      //   console.log("checked");
      //   console.log(submit_btn.prop());
      submit_btn.addClass("btnEnabled").prop("disabled", false);
    } else {
      //   console.log("not checked");
      submit_btn.removeClass("btnEnabled").prop("disabled", true);
    }
  }

  //   メールアドレスの同一チェック

  let input_mail = $("#email");
  let check_mail = $("#check_email");

  //   メールアドレスとプライバシーポリシーのチェック
  let check_flags = {
    privacy: false,
    email: false,
  };

  check_mail.on("input change", function () {
    // console.log($(this));

    if (input_mail.val() !== $(this).val()) {
    //   console.log("not mache!");
      $(this).parent().addClass("isCaution");
      check_flags.email = false;
      toggleSubmitBtn(check_flags);
    } else {
      check_flags.email = true;
    //   console.log("match");
      $(this).parent().removeClass("isCaution");

      toggleSubmitBtn(check_flags);
    }
  });

  // form の個人情報取扱いに関する同意でボタンの有効無効を切り替える
  let privacycheck = $("#privacypolicy_check");
  let submit_btn = $("#form_submit_btn");

  privacycheck.on("change", function () {
    check_flags.privacy = $(this).prop("checked");

    toggleSubmitBtn(check_flags);
  });

  // 生年月日の選択肢を生成

  let currentDate = new Date();
  let year_range_offset = {
    start: 1950,
    end: 2020,
    select: -20,
  };

  console.log(year_range_offset);
  let birthday_year = document.querySelector("#birthday_year");
  let birthday_month = document.querySelector("#birthday_month");
  let birthday_day = document.querySelector("#birthday_day");

  function createOptionForElements(elem, val, select) {
    let option = document.createElement("option");
    option.text = val;
    option.value = val;
    if (val == select) {
      option.selected = true;
    }
    if(elem){
        elem.appendChild(option);
    }
  }

  //年の生成
  for (
    let i = year_range_offset.start;
    i <= year_range_offset.end;
    i++
  ) {
    if (i === currentDate.getFullYear() + year_range_offset.select) {
      createOptionForElements(birthday_year, "", "");
    }
      createOptionForElements(birthday_year, i);
  }
  //月の生成
  for (let i = 1; i <= 12; i++) {
    if(i === 1){
      createOptionForElements(birthday_month, "");
    }
    createOptionForElements(birthday_month, i);
  }
  //日の生成
  for (let i = 1; i <= 31; i++) {
        if (i === 1) {
          createOptionForElements(birthday_day, "");
        }
    createOptionForElements(birthday_day, i);
  }

  /**
   * 日付を変更する関数
   */
  function changeTheDay() {
    //日付の要素を削除
    birthday_day.innerHTML = "";

    //選択された年月の最終日を計算
    let lastDayOfTheMonth = new Date(
      birthday_year.value,
      birthday_month.value,
      0
    ).getDate();

    //選択された年月の日付を生成
    for (let i = 1; i <= lastDayOfTheMonth; i++) {
      createOptionForElements(birthday_day, i);
    }
  }

  birthday_year.addEventListener("change", function () {
    changeTheDay();
  });

  birthday_month.addEventListener("change", function () {
    changeTheDay();
  });
}
